import { toTitleCase } from '@agilepoint/utils-common';
import { AuthenticationProviderKeys, IAuthenticationFormFields } from '../types';

export type AuthenticationSettingsResponse = ReturnType<typeof getAuthenticationSettingsJSON>
export const getAuthenticationSettingsJSON = (formData: IAuthenticationFormFields, optionsData: {
    name: string;
    value: {
        iconName: string;
        markedAsDefault: boolean;
    };
    key: AuthenticationProviderKeys;
}[]) => {
    const { activeDirectoryConfiguration, authentication, googleConfiguration, identityServerConfiguration,
        officeConfiguration, officeConfigurationChina, oktaConfiguration, salesforceConfiguration, serverInstanceURL,
        amazonCognitoConfiguration, pingFederateConfiguration } = formData;

    return {
        'ServerConfiguration': {
            'DevelopmentServerInstanceUrl': '',
            'StagingServerInstanceUrl': '',
            'ProductionServerInstanceUrl': serverInstanceURL
        },
        'SalesforceConfiguration': {
            'ConsumerKey': salesforceConfiguration.consumerKey,
            'ConsumerSecret': salesforceConfiguration.consumerSecret,
            'isSelected': authentication.includes(AuthenticationProviderKeys.Salesforce)
        },
        'OfficeConfiguration': {
            'ClientId': officeConfiguration.clientId,
            'ReturnURL': officeConfiguration.returnURL,
            'Resource': officeConfiguration.resource,
            'UseMSAuthenticatorApp': officeConfiguration.useMSAuthenticatorApp,
            'isSelected': authentication.includes(AuthenticationProviderKeys.MSAzureActiveDirectory)
        },
        'OfficeConfigurationChina': {
            'ClientId': officeConfigurationChina.clientId,
            'ReturnURL': officeConfigurationChina.returnURL,
            'Resource': officeConfigurationChina.resource,
            'UseMSAuthenticatorApp': officeConfigurationChina.useMSAuthenticatorApp,
            'isSelected': authentication.includes(AuthenticationProviderKeys.MSAzureActiveDirectoryChina)
        },
        'IdentityServerConfiguration': {
            'ClientId': identityServerConfiguration.clientId,
            'Authority': identityServerConfiguration.authority,
            'isSelected': authentication.includes(AuthenticationProviderKeys.IdentityServer)
        },
        'OktaConfiguration': {
            'ClientId': oktaConfiguration.clientId,
            'Authority': oktaConfiguration.authority,
            'isSelected': authentication.includes(AuthenticationProviderKeys.Okta)
        },
        'GoogleConfiguration': {
            'ClientId': googleConfiguration.clientId,
            'ReturnURL': googleConfiguration.returnURL,
            'Resource': googleConfiguration.resource,
            'isSelected': authentication.includes(AuthenticationProviderKeys.GoogleConfiguration)
        },
        'ActiveDirectoryConfiguration': {
            'Domain': activeDirectoryConfiguration.domain,
            'EnableJWT': activeDirectoryConfiguration.enableJWT,
            'AudienceURL': activeDirectoryConfiguration.audienceURL,
            'isSelected': authentication.includes(AuthenticationProviderKeys.ActiveDirectory)
        },
        'AgilePiontNXConfiguration': { //API Payload needs 'AgilePiontNXConfiguration' instead of 'AgilePointNXConfiguration'
            'isSelected': authentication.includes(AuthenticationProviderKeys.AgilePointID)
        },
        'PingFederateConfiguration': {
            'ClientId': pingFederateConfiguration?.clientId,
            'Authority': pingFederateConfiguration?.authority,
            'UsernameClaimType': pingFederateConfiguration?.usernameClaimType,
            'isSelected': authentication.includes(AuthenticationProviderKeys.PingFederate)
        },
        'AmazonCognitoConfiguration': {
            'ClientId': amazonCognitoConfiguration?.clientId,
            'Authority': amazonCognitoConfiguration?.authority,
            'UserImpersonationScopeURL': amazonCognitoConfiguration?.userImpersonationScopeURL,
            'isSelected': authentication.includes(AuthenticationProviderKeys.AmazonCognito)
        },
        'defaultConfig': toTitleCase(optionsData.find((option) => option.value.markedAsDefault)?.key!)
    };
};
